import * as React from 'react';

import type { W_Job_JobPreview_VM } from 'ab-api/web/job/findByIdForPreview';

import { SegmentLabel } from '@acceligentllc/storybook';

import LockedValue from 'af-components/LockedValue';

import styles from './styles.module.scss';

interface OwnProps {
	allowCustomerSignature: W_Job_JobPreview_VM['allowCustomerSignature'];
}

type Props = OwnProps;

class JobAdditionalInfoPreview extends React.PureComponent<Props> {
	render() {
		const { allowCustomerSignature } = this.props;

		return (
			<div className={styles['job-preview__additional-info']}>
				<div className="m-b-m">
					<SegmentLabel
						label="Customer Signature"
						tooltip="Settings and permissions related to authorizing customer signatures on field reports generated for this job and its work orders."
					/>
				</div>
				<div>
					<LockedValue label="Allow Customer Signature" value={allowCustomerSignature ? 'YES' : 'NO'} />
				</div>
			</div>
		);
	}

}

export default React.memo(JobAdditionalInfoPreview);
